<template>
  <van-popup class="confirm-dialog" round v-model="showPopup">
    <div class="confirm-dialog__header">
      <div class="title">{{ title }}</div>
    </div>
    <div class="confirm-dialog__body">
      <input
        type="text"
        class="input"
        :placeholder="placeholder"
        maxlength="30"
        v-model="inputVal"
      >
    </div>
    <div class="confirm-dialog__footer">
      <div class="btn" @click="cancel">取消</div>
      <div class="btn confirm" @click="confirm">确认</div>
    </div>
  </van-popup>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: "confirmAccount",
  data() {
    return {
      showPopup: false,
      inputVal: '',
    }
  },
  props: {
    title: {
      type: String,
      default: '账号确认'
    },
    placeholder: {
      type: String,
      default: '请再次输入充值账号'
    },
    type: {
      type: Number,
      default: 1,
    },
    confirmVal: {
      type: String,
      default: ''
    }
  },
  methods: {
    clearData() {
      this.inputVal = '';
    },
    openDialog() {
      this.showPopup = true
    },
    cancel() {
      this.clearData()
      this.showPopup = false;
    },
    confirm() {
      if (this.confirmVal !== this.inputVal) {
        Toast('两次输入结果不一致')
        return
      }
      const result = this.inputVal
      this.clearData()
      this.showPopup = false;
      this.$emit('getResult', result);
    },
  },
  created() {
  },
}
</script>

<style lang="scss" scoped>
.confirm-dialog {
  width: 6rem;

  &__header {
    display: flex;
    font-size: 0.32rem;
    height: .98rem;
    justify-content: center;
    align-items: center;
    box-shadow: 0 1px 0 0 rgba(230, 230, 230, 1);

    .title {
      font-weight: 400;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    margin: .32rem .46rem;

    > .title {
      font-size: .24rem;
      color: #787878;
    }

    > .input {
      display: block;
      width: 100%;
      height: .72rem;
      background: #FFFFFF;
      border: .02rem solid #CCCCCC;
      font-size: .24rem;
      border-radius: .08rem;
      margin: .16rem 0;
      padding-left: .16rem;
      box-sizing: border-box;
    }

    > .tips {
      font-size: .2rem;
      color: #F29254;
      margin-bottom: .32rem;
    }
  }

  &__footer {
    display: flex;
    height: .97rem;
    line-height: .97rem;
    border-top: .02rem solid #E6E6E6;

    > .btn {
      flex: 1;
      text-align: center;
      font-size: .32rem;
      color: #383838;

      &:first-child {
        border-right: .02rem solid #E6E6E6;
      }

      &.confirm {
        color: #3399FF;
      }
    }
  }
}
</style>
